(function (global) {

  var getGrid = function () {
    return Core.grid.reference;
  };

  var getReferenceName = function () {
    return getGrid()._dataSource.referenceName;
  };

  var reloadFiltersAndData = function (params) {
    var grid = getGrid();

    var newState = {};
    if (typeof params['PageIndex'] !== 'undefined') {
      newState.PageIndex = params['PageIndex'];
    }
    if (typeof params['CurrentFilter'] !== 'undefined') {
      newState.CurrentFilter = params['CurrentFilter'];
    }
    if (typeof params['UnselectAllRecords'] !== 'undefined' && params['UnselectAllRecords'] === true) {
      grid.grid.setSelectedRows([]); // Сбросить выделение записей справочника
    }
    if (typeof params['IsEnabled'] !== 'undefined') {
      var currentFilter = newState.CurrentFilter || grid.state.CurrentFilter;
      $.extend(newState, {
        CurrentFilter: $.extend({}, currentFilter, {
          IsEnabled: params['IsEnabled']
        })
      });
    }

    // Обновляем информацию о фильтрах.
    grid.updateState(newState);

    if (!!grid.updateFilter) grid.updateFilter();
    if (!!grid.updateFooter) grid.updateFooter();

    grid.reloadData(newState).always(function (data) {
      // Обновляем информацию о фильтрах.
      grid.updateState({
        SavedFilters: data.State.SavedFilters
      });
      global.Filters.setupFiltersState();
    });
  };

  /**
   * Функции отвечающие за работу с пользовательскими фильтрами
   * @namespace Filters
   * @ignore
   */
  global.Filters = {
    isChanged: false,
    currentID: "0",
    contextMenuElementSelector: '#filters_menu_caption',
    contextMenuSettings: { width: 270, shiftY: 37 },
    referenceName: WA.CR.getReferenceCode(),
    referenceView: WA.CR.getReferenceView(),
    placementContext: ''
  };

  /**
   * Сохраняет список элементов контекстного меню.
   * @function Filters.initFilterMenuItems
   * @ignore
   */
  Filters.initFilterMenuItems = function (items, opt_referenceName, opt_referenceView, opt_placementContext) {
    Filters.menuItems = items;
    Filters.referenceName = opt_referenceName || WA.CR.getReferenceCode();
    Filters.referenceView = opt_referenceView || WA.CR.getReferenceView();
    Filters.placementContext = opt_placementContext;
    if (!Filters.placementContext) {
      $.when(WA.SideBarInit).then(function () {
        Filters.placementContext = Core.grid.getPlacementContext();
      });
    }
  };

  /**
   * Создание контестного меню для выбора фильтра справочника(минитулбар, справа)
   * @function Filters.createReferenceMenu
   * @param {string} selector селектор компоненты
   * @param {Array.<plainObject>} data доступные пункты меню
   * @ignore
   */
  Filters.createReferenceMenu = function (selector, data) {
    //Здесь сделаем фильтр с идексом 0 последним в списке.
    var autoFilter = null;
    var saveFilterItemIndex = data.length - 1;
    for (var i = 0; i < data.length; i++) {
      if (data[i]["name"] == "0") {
        autoFilter = data[i];
        data.splice(i, 1);
      };
      if (data[i]["name"] == "save_filter") {
        saveFilterItemIndex = i;
      }
    };
    if (!!autoFilter) {
      // Убираем с последнего фильтра бордер снизу, т.е. теперь автофильтр последний.
      var prevLast = data[saveFilterItemIndex - 1];
      if (prevLast['name'] !== '-1') {
        prevLast.bottomSeparator = false;
      }
      autoFilter.bottomSeparator = true;
      // Добавялем перед "Сохранить фильтр" или в самый конец.
      data.splice(saveFilterItemIndex, 0, autoFilter);
    }

    try {
      var settings = $.extend({}, Filters.contextMenuSettings, selectToolbarBtnOnShowContextMenu(selector));
      Filters.currentMenu = new WA.components.menus.BaseContextMenu(selector, data, settings);
      Filters.currentMenu.render();
      Filters.currentMenu.bind("itemSelect", function (item) {
        switch (item.name) {
          case 'save_filter':
            window.Filters.saveCurrentFilter($(selector));
            break;
          case 'save_filter_as':
            window.Filters.saveCurrentFilterAs($(selector));
            break;
          case 'delete_filter':
            window.Filters.deleteFilter($(selector));
            break;
          default:
            WA.SRV.reference.setFilter(Filters.referenceName, item.name, Filters.referenceView, Filters.placementContext).success(function (newCurrentFilter) {
              if (newCurrentFilter.ID !== "-1") newCurrentFilter.IsEnabled = true;
              reloadFiltersAndData({
                CurrentFilter: newCurrentFilter,
                PageIndex: 0,
                UnselectAllRecords: true
              });
              // Снимаем выделение с кнопки тулбар, если выбрали "Без фильтра".
              if (item.name === "-1") {
                $(selector).removeClass('selected');
              } else {
                $(selector).addClass('selected');
              }
            });
        };
      });
    } catch (ex) {
    }
  };


  Filters.saveCurrentFilter = function (el) {
    Filters.saveFilter(el, false);
  };

  Filters.saveCurrentFilterAs = function (el) {
    Filters.saveFilter(el, true)
  };


  /**
   * Сохранение текущего фильтра в новый
   * @function Filters.saveFilter
   * @ignore
   */
  Filters.saveFilter = function (el, createNew) {
    if ($(el).hasClass("disabled")) return;
    var CP = WA.components;

    var filters = Filters.currentMenu.items;
    var options = {};

    for (var i = 0; i < filters.length; i++) {
      if (filters[i].name != "-1" && filters[i].name != "0" && filters[i].name != "save_filter" && filters[i].name != "save_filter_as" && filters[i].name != "delete_filter") {
        options[filters[i].name] = filters[i].label;
      }
    };

    if (Filters.currentID == "0" && !$(".resetFilterState").is(":visible")) {
      return ShowMessage(L("FILTER_IS_EMPTY"), L("NOTHING_TO_SAVE"));
    };

    var form = new CP.forms.FormBuilder("filter_save_modal")
        .setOrientation("horizontal")
        .addPick("FILTER_NAME", options, null, null, true, { "isRequired": true });
    form.displayErrors = "tip";

    var dialog = new CP.dialogs.BaseDialog();
    dialog.title = createNew ? L("SAVE_NEW_FILTER") : L("SAVE_FILTER");
    dialog.html = form.render();
    dialog.isShowCancelButton = true;
    dialog.ok = function () {
      if (form.isValid() === false) return false;
      var filterID = form.getValue("FILTER_NAME");
      var filterName = form.getDisplayValue("FILTER_NAME");
      if (!createNew) {
        if (Filters.currentID != "0")
          WA.SRV.reference.saveFilter(Filters.referenceName, Filters.currentID, filterName, Filters.referenceView, Filters.placementContext).success(function (newCurrentFilter) {
            reloadFiltersAndData({
              CurrentFilter: newCurrentFilter
            });
          });
        else
          if (filterID == "") {
            WA.SRV.reference.createNewFilter(Filters.referenceName, filterName, Filters.referenceView, Filters.placementContext).success(function (newCurrentFilter) {
              reloadFiltersAndData({
                CurrentFilter: newCurrentFilter
              });
            });
          } else {
            WA.SRV.reference.saveFilter(Filters.referenceName, filterID, filterName, Filters.referenceView, Filters.placementContext).success(function (newCurrentFilter) {
              reloadFiltersAndData({
                CurrentFilter: newCurrentFilter
              });
            });
          }
      } else {
        WA.SRV.reference.createNewFilter(Filters.referenceName, filterName, Filters.referenceView, Filters.placementContext).success(function (newCurrentFilter) {
          reloadFiltersAndData({
            CurrentFilter: newCurrentFilter
          });
        });
      };
    };
    //$("#save_filter").addClass("disabled").attr("title", L("FILTER_NOT_CHANGED"));
    dialog.bind("onOpen", function () {
      var autoFilterName;
      var index = getElementIndexByAttr(filters, "name", "0");
      if (parseInt(index, 10) >= 0) {
        autoFilterName = filters[index].label;
      } else {
        if (!createNew) {
          index = getElementIndexByAttr(filters, "name", Filters.currentID);
          autoFilterName = filters[index].label;
        } else {
          var maxFilterID = _(_(filters).map(function (f) {
            return +f.name; // Преобразуем в число, что бы вычислить max.
          })).max();
          autoFilterName = L('AUTO_FILTER_LABEL') + ' ' + Math.max(maxFilterID + 1, 1); //Если фильтров нет, то max вернет -Infinity, а имя фильтра сделаем с номером 1.
        }
      }
      form.setValue("FILTER_NAME", '-1', autoFilterName);

      $("#filter_name").keypress(function (ev) {
        if (ev.keyCode == 13) {
          dialog.ok();
          dialog.close();
        };
      });
    });
    dialog.show();

    BindHelpIcoClickOnModalWindow('SaveFilter');
  };

  /**
   * Удаление текущего фильтра
   * @function Filters.removeReferenceMenu
   * @ignore
   */
  Filters.deleteFilter = function (el) {
    if ($(el).hasClass("disabled")) return;
    var selected = Filters.currentMenu.getSelectedItem();
    var dialog = new WA.components.dialogs.BaseDialog();
    dialog.title = L("CONFIRMATION");
    dialog.height = 'auto',
    dialog.isShowCancelButton = true;
    dialog.setHtml(format('{0} "{1}"?', L("FILTER_DELETE_CONFIRMATION"), escapeHtml(selected.label)));
    dialog.bind("ok", function () {
      WA.SRV.reference.removeFilter(Filters.referenceName, selected.name, Filters.referenceView, Filters.placementContext).success(function (result) {
        clearFilter();
      });
    });
    dialog.show();
  };

  /**
   * Обновление визуальных компонент ответственных за фильтры.
   * Здесь же, происходит выделение текущего фильтра в меню.
   * @function Filters.setupFiltersState
   * @ignore
   */
  Filters.setupFiltersState = function () {
    var grid = getGrid();
    var selectedID = "-1";
    var filterID = '' + grid.state.CurrentFilter.ID;
    Filters.currentID = filterID;

    var filters = grid.state.SavedFilters;
    if (!!filters) {
      var emptyItem = {
        "name": "-1",
        "label": L("DEFAULT_EMPTY_FILTER"),
        "bottomSeparator": true,
        'selected': (filterID === '-1')
      };
      var wellFormedFilters = [emptyItem];
      for (var filterName in filters) {
        var item = {
          "name": filterName,
          "label": filters[filterName]
        };
        if (filterName == filterID) {
          item.selected = true;
          selectedID = filterID;
        }
        item['stataction'] = "SetSavedFilter";
        wellFormedFilters.push(item);
      };

      // Добавляем кнопки только, если есть компонента для управления фильтрами.
      if ($("#filters_menu_caption").length === 0) {
        // У последнего фильтра рисуем нижнюю границу.
        wellFormedFilters[wellFormedFilters.length - 1]['bottomSeparator'] = true;

        var btnsDisabled = (selectedID === '-1' || typeof grid === "undefined"); //Замечание №69912
        //TODO Если задизэйблены, то нужно еще и подсказку изменить, но контекстное меню этого не поддерживает.
        wellFormedFilters.push({ name: 'save_filter', label: L('SAVE_CURRENT_FILTER'), icon: 'filterSave-16', disabled: btnsDisabled, "tooltip": format("{0}.\n{1}.", L("SAVE_CURRENT_FILTER"), L("AVAILABLE_ONLY_IF_FILTER_EXIST")) });
        wellFormedFilters.push({ name: 'save_filter_as', label: L('SAVE_CURRENT_FILTER_AS'), disabled: btnsDisabled, "tooltip": format("{0}\n{1}.", L("SAVE_CURRENT_FILTER_AS"), L("AVAILABLE_ONLY_IF_SAVED_FILTER_EXIST")) });
        wellFormedFilters.push({ name: 'delete_filter', label: L('DELETE_CURRENT_FILTER'), icon: 'delete-16', disabled: btnsDisabled, "tooltip": format("{0}.\n{1}.", L("DELETE_CURRENT_FILTER"), L("AVAILABLE_ONLY_IF_FILTER_EXIST")) });
      }

      Filters.menuItems = wellFormedFilters;

      if (!!Filters.contextMenuElementSelector)
        Filters.createReferenceMenu(Filters.contextMenuElementSelector, wellFormedFilters);

      // Обновляем компоненту управлющую фильтрами.
      Filters.updateFilterMenuWidget(filters, selectedID);

      // Устанавливаем активность/неактивность кнопки ленты "Текущий фильтр".
      Core.toolBars.reference.SetCurrentFilterState();
    };
  };
  /**
   * Обновляем компоненту управляющую фильтрами.
   * @function Filters.updateFilterMenuWidget
   * @ignore
   */
  Filters.updateFilterMenuWidget = function (filters, selectedID) {
    var jFilterMenuWidget = $("#filters_menu_caption");
    if (jFilterMenuWidget.length > 0 && !!filters) {
      jFilterMenuWidget.text(filters[selectedID]);

      if (selectedID == "-1") {
        jFilterMenuWidget.text(L("DEFAULT_EMPTY_FILTER"));
        emptyItem.selected = true;
      } else {
        jFilterMenuWidget.text(filters[selectedID].trunc(50));
      }

      //Отключение кнопок
      //-1 - <Отсутсвует>
      if (selectedID === '-1') {
        enableFilterActions();
      } else {
        disableFilterActions();
      }
    }
  };

  /// <summary>
  /// Очищает фильтр.
  /// </summary>
  /// <remarks></remarks>
  Filters.resetFilter = function () {
    var grid = getGrid();
    //Автофильтр придется тоже удалить
    if (grid) {
      WA.SRV.reference.removeFilter(Filters.referenceName, "0", Filters.referenceView, Filters.placementContext).success(function (result) {
        clearFilter();
      });
    } else {
      clearFilter();
    }
  }

  /// <summary>
  /// Вкл./выкл фильтр.
  /// </summary>
  /// <remarks></remarks>
  Filters.changeFilterState = function (isEnabled) {
    var data = {
      IsEnabled: isEnabled,
      PageIndex: 0 // Перекинуть на первую страницу
    };
    getGrid().grid.setSelectedRows([]); // Сбросить выделение записей справочника
    reloadFiltersAndData(data);
  };

  function clearFilter() {
    var grid = getGrid();
    var currentFilter = grid.state.CurrentFilter;

    var newSavedFilters = grid.state.SavedFilters;
    delete newSavedFilters[currentFilter.ID];

    reloadFiltersAndData({
      CurrentFilter: $.extend({}, currentFilter, {
        ID: '-1',
        Name: '',
        DisplayValue: '',
        DisplayHint: '',
        Expression: '',
        ColumnsFilter: {}
      }),
      SavedFilters: newSavedFilters,
      PageIndex: 0
    });
  };

  function enableFilterActions() {
    $("#delete_filter, #save_filter_as, #save_filter").removeClass("disabled");
    $("#delete_filter").attr('title', L("DELETE_CURRENT_FILTER"));
    $("#save_filter_as").attr('title', L("SAVE_CURRENT_FILTER_AS"));
    $("#save_filter").attr('title', L("SAVE_CURRENT_FILTER"));
  };
  function disableFilterActions() {
    $("#delete_filter, #save_filter_as, #save_filter").addClass("disabled");
    $("#delete_filter").attr('title', L("DELETE_CURRENT_FILTER") + "\n" + L("AVAILABLE_ONLY_IF_FILTER_EXIST"));
    $("#save_filter_as").attr('title', L("SAVE_CURRENT_FILTER_AS") + "\n" + L("AVAILABLE_ONLY_IF_SAVED_FILTER_EXIST"));
    $("#save_filter").attr('title', L("SAVE_CURRENT_FILTER") + "\n" + L("AVAILABLE_ONLY_IF_FILTER_EXIST"));
  };

})(window);
